
import React, { useState, useContext, useRef, useLayoutEffect, useEffect } from "react";
import ConopsSidebar from "../conops-sidebar/conopssidebar";
import apiClientconops from "../../../ApiEndpoint/apiClientconops";
import apiUrlconops from "../../../ApiEndpoint/configconops";
import ReactMarkdown from "react-markdown";
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import { Modal, Tabs, Input } from 'antd';
// import { getFromDB, setToDB, STORE_NAMES } from "./../../utils/indexedDBUtil";
import { useAuthContext } from "../../../utils/AuthContext";
import avatar from "../../../assets/avatar.png";
import "./conopshome.css"

import { Link as RouterLink, useNavigate } from 'react-router-dom';
const remarkGfm = require('remark-gfm').default || require('remark-gfm');


const ConopsHome = () => {
  const { user } = useAuthContext();
  const [inputText, setInputText] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const { messages, setMessages, moveToBottom, setMoveToBottom, showWelcome, setShowWelcome, fetchSessionsFn } = useContext(ConopsContext);
  const bottomRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [promptSearchText, setPromptSearchText] = useState("");
  const [categories, setCategories] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [isPromptLoading, setIsPromptLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(0);

  const socketRef = useRef(null);
  //Modal toggle
  const handleModalChange = () => {
    setIsModalVisible(true);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  //Helper to group prompts by category:
  const getPromptsByCategory = (category) =>
    prompts.filter(
      (p) =>
        p.category === category &&
        p.title.toLowerCase().includes(promptSearchText.toLowerCase())
    );


  const navigate = useNavigate();


  // Scroll to bottom after messages update
  useLayoutEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [messages]);






  // ✅ Setup WebSocket connection once
  // useEffect(() => {
  //   let wsUrl = 'wss://unlogical-superprecariously-shanae.ngrok-free.dev/askmeconops'
  //   // let wsUrl;
  //   // if (window.location.hostname === "localhost") {
  //   //   // Local dev
  //   //   wsUrl = apiUrlconops.replace(/^http/, "ws");
  //   //   wsUrl = wsUrl.replace(/\/$/, "") + "/askme";
  //   // } else {
  //   //   // Live API Gateway
  //   //   wsUrl = "wss://4a7549c9c8c2.ngrok-free.app/askme";
  //   // }


  //   socketRef.current = new WebSocket(wsUrl);

  //   socketRef.current.onopen = () => {

  //   };

  //   socketRef.current.onmessage = (event) => {
  //     let data;
  //     try {
  //       data = JSON.parse(event.data);
  //     } catch {
  //       data = { result: event.data }; // fallback for plain text
  //     }


  //     if (data.session_id) {
  //       sessionStorage.setItem("currentSessionId", data.session_id);
  //       if (fetchSessionsFn) fetchSessionsFn();
  //     }

  //     // ✅ Handle streaming chunks
  //     if (data.type === "chunk") {
  //       setMessages((prev) => {
  //         const last = prev[prev.length - 1];
  //         if (last?.sender === "bot" && !last.complete) {
  //           const updated = [...prev];
  //           updated[updated.length - 1].text += data.content;
  //           return updated;
  //         } else {
  //           return [...prev, { text: data.content, sender: "bot", complete: false }];
  //         }
  //       });
  //     }

  //     // ✅ Handle end of stream
  //     if (data.type === "end") {
  //       setMessages((prev) => {
  //         const updated = [...prev];
  //         if (updated.length > 0) {
  //           updated[updated.length - 1].complete = true;
  //         }
  //         return updated;
  //       });
  //       setIsTyping(false);
  //     }

  //     // ✅ Handle fallback non-streamed message
  //     if (!data.type) {
  //       const botMessage = {
  //         text: data.result && data.result.trim() !== ""
  //           ? data.result
  //           : "The request couldn’t be processed. Try simplifying your prompt — break it into smaller parts",
  //         sender: "bot",
  //         complete: true
  //       };
  //       setMessages((prev) => [...prev, botMessage]);
  //       setIsTyping(false);
  //     }
  //   };

  //   socketRef.current.onclose = () => {

  //   };

  //   return () => {
  //     socketRef.current && socketRef.current.close();
  //   };
  // }, [apiUrlconops, fetchSessionsFn]);

  // ✅ Handle sending messages
  const handleSendMessage = async () => {
    if (inputText.trim() === "") return;

    const userMessage = { text: inputText, sender: "user" };
    setMessages((prev) => [...prev, userMessage]);
    setInputText("");
    setMoveToBottom(true);
    setShowWelcome(false);
    setIsTyping(true);

    const userEmail = user?.email;
    const currentSessionId = sessionStorage.getItem("currentSessionId");

    // Payload for WS or REST
    const payload = {
      query: inputText,
      user_email: userEmail,
      flag: parseInt(selectedOption, 10)
    };
    if (currentSessionId) payload.session_id = currentSessionId;

    try {
      // --- Use WebSocket if connected ---
      // if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      //   socketRef.current.send(JSON.stringify(payload));
      // } else {
      // --- Fallback to REST ---
      const response = await apiClientconops.post(
        `${apiUrlconops}/askmeconops`,
        {}, // empty body
        { params: payload } // query params stay the same
      );

      const botText = response.data.result || "The request couldn’t be processed. Try simplifying your prompt — break it into smaller parts";
      console.log(botText, "bottext")

      if (!currentSessionId && response?.data.session_id) {
        sessionStorage.setItem("currentSessionId", response?.data.session_id);
        if (fetchSessionsFn) fetchSessionsFn();
      }

      const botMessage = { text: botText, sender: "bot" };
      setMessages((prev) => [...prev, botMessage]);
      setIsTyping(false);
      // }
    } catch (error) {
      console.error("Error fetching response:", error);
      const errorResponse = {
        text: "The request couldn’t be processed. Try simplifying your prompt — break it into smaller parts",
        sender: "bot",
      };
      setMessages((prev) => [...prev, errorResponse]);
      setIsTyping(false);
    }
  };

  // ✅ Send on Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleSessionSelect = async (sessionId) => {
    const userEmail = user?.email;
    if (!userEmail) return;

    try {
      const res = await apiClientconops.get(`${apiUrlconops}/get_session_history`, {
        params: { user_email: userEmail, session_id: sessionId }
      });

      const formattedMessages = res.data.map((entry) => ({
        text: entry.content,
        sender: entry.role === "user" ? "user" : "bot"
      }));

      setMessages(formattedMessages);
      setShowWelcome(false);
      setMoveToBottom(true);
    } catch (err) {
      console.error("Failed to load session history", err);
    }
  };

  const fixMarkdownTables = (text) => {
    // Replace escaped newlines with actual newlines
    let fixed = text.replace(/\\n/g, '\n');

    // Fix accidental double pipes between header and separator
    fixed = fixed.replace(/(\|[^\n]+)\|\s*\|(-{2,})/g, '$1\n$2');

    // If someone added `|` at the start of separator line again, fix that
    fixed = fixed.replace(/\n\|(-{2,})/g, '\n$1');

    return fixed;
  }
  const renderMarkdownLink = ({ href, children }) => {
    const cleanHref = href?.startsWith("/action:") ? href.slice(1) : href;

    if (cleanHref?.startsWith("action:")) {
      const parts = cleanHref.split(":");
      const type = parts[1];
      const value = parts.slice(2).join(":");

      return (
        <RouterLink
          to="/smart-prospecting/data"
          state={type === "facility" ? { registryId: value } : { company: value }}
          style={{ color: "#1a73e8", textDecoration: "underline" }}
        >
          {children}
        </RouterLink>
      );
    }

    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-2 col-lg-4 col-md-4 col-2">
          <ConopsSidebar onSessionSelect={handleSessionSelect} isTyping={isTyping} />
        </div>
        <div className="col-xl-10 col-lg-8 col-md-8 col-10 p-0">
          <div className="container-fluid d-flex flex-column justify-content-center align-items-center chat-container-2 p-0">
            {showWelcome && (
              <div className="welcome-text">
                <h5 style={{ color: "#55555A", textAlign: "center" }}>
                  Welcome to the
                </h5>
                <h3>Veolia Smart Growth Engine - Conops</h3>
              </div>
            )}

            <div className="messages-container-2">
              {messages.map((msg, index) => (
                <div key={index} className={`message ${msg.sender}`}>
                  {msg.sender === "bot" ? (
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      components={{ a: renderMarkdownLink }}
                    >
                      {fixMarkdownTables(msg.text)}
                    </ReactMarkdown>
                  ) : (
                    msg.text
                  )}
                </div>
              ))}
              {isTyping && (
                <div className="typing-indicator">
                  <img src={avatar} alt="Chat" style={{ width: '2rem', height: '2rem', cursor: 'pointer' }} />
                  Neo is thinking
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}
              <div ref={bottomRef} />
            </div>

            <div
              className={`textarea-container ${moveToBottom ? "move-bottom" : "center-textarea"
                }`}
            >
              <textarea
                className="form-control fixed-height"
                rows="3"
                id="floatingTextarea"
                placeholder="How can I help?"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={handleKeyDown}

              ></textarea>


              <div
                className="btn-group"
                role="group"
                style={{
                  top: "50px",
                  right: "210px",
                  height: "95px",
                  zIndex: 1,
                  width: "16rem"
                }}
              >
                <select
                  style={{
                    height: '32px',
                    borderColor: '#dee2e6',
                    fontSize: '12px',
                    color: '#666f86'

                  }}
                  className="form-select textarea-dropdown"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}

                >
                  <option value="0">All</option>
                  <option value="1">EPA</option>
                  <option value="2">Web Search</option>
                  <option value="3">Document Details</option>
                  <option value="4">Contact Details</option>
                  <option value="5">Competitor Insights</option>
                  <option value="6">Social Media Analysis </option>
                  <option value="7">Bluefield Research </option>
                  <option value="8">Contract End Date Research</option>

                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="bottom-center-text">
              <p style={{ fontSize: '12px' }}>Answers from Smart Growth Engine sometimes need to be validated against source</p>
            </div>
          </div>
        </div>

      </div>

      <Modal
        title="Prompt Suggestions"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1000}
        className="tall-modal"
      >


        {/* Tabs on the left, filtered prompt list on right */}
        <Tabs
          activeKey={activeTabKey}
          onChange={(key) => setActiveTabKey(key)}
          tabPosition="left"
          style={{ height: 500, overflowY: "scroll" }}
          items={categories.map((cat) => ({
            key: cat,
            label: cat,
            children: (
              <div>
                {getPromptsByCategory(cat).length > 0 ? (
                  getPromptsByCategory(cat).map((prompt, idx) => (
                    <div key={idx} className="prompt-card" style={{ marginBottom: 16 }}>
                      <h5><strong>{prompt.title}</strong></h5>
                      <textarea
                        style={{ width: "100%", height: 140, resize: "vertical" }}
                        defaultValue={prompt.prompt?.trim()}
                        onChange={(e) => prompt.edited = e.target.value}
                      />
                      <button
                        className="btn btn-sm btn-primary mt-2"
                        onClick={() => {
                          setInputText(prompt.edited || prompt.prompt?.trim());
                          setIsModalVisible(false);
                        }}
                      >
                        Use this prompt
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No matching prompts found.</p>
                )}
              </div>
            )
          }))}
        />
      </Modal>




    </div >
  );
};
export default ConopsHome;

